import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import StatusLayout from "./StatusLayout";
import { useCase } from "../../context/CaseContext";
import {
  downloadFurtherActionNotice,
  downloadGenericResult,
  submitCloseCase,
  submitNoAction,
  submitReferCase,
  downloadReferralDate
} from "../../lib/everifyStatusApi";
import { useClosureReasons } from "../../hooks/everify/useClosureReasons";

const PendingReferralPage = () => {
  const { activeCaseNumber } = useCase();
  const navigate = useNavigate();
  const [noticeDownloaded, setNoticeDownloaded] = useState(false);
  const [acknowledgements, setAcknowledgements] = useState({
    employeeAcknowledged: false,
    documentsGiven: false,
  });
  const [selectedReason, setSelectedReason] = useState("");
  const [actionLoading, setActionLoading] = useState(null);
  const [downloadNoticeLoading, setDownloadNoticeLoading] = useState(false);
  const [downloadResultLoading, setDownloadResultLoading] = useState(false);
  const [downloadReferralDateLoading, setDownloadReferralDateLoading] = useState(false);

  const {
    data: reasons = [],
    isLoading: reasonsLoading,
  } = useClosureReasons(activeCaseNumber, noticeDownloaded);

  const allAcknowledged = Object.values(acknowledgements).every(Boolean);

  const handleCheckboxChange = (name) => {
    setAcknowledgements((prev) => ({
      ...prev,
      [name]: !prev[name],
    }));
  };

  const handleDownloadNotice = async () => {
    try {
      setDownloadNoticeLoading(true);
      await downloadFurtherActionNotice(activeCaseNumber);
      setNoticeDownloaded(true);
    } catch (error) {
      toast.error("Unable to download the notice.");
    } finally {
      setDownloadNoticeLoading(false);
    }
  };
  const handleDownloadReferralDate = async () => {
    try {
      setDownloadReferralDateLoading(true);
      await downloadReferralDate(activeCaseNumber);
    } catch (error) {
      toast.error("Unable to download Referral Date Confirmation.");
    } finally {
      setDownloadReferralDateLoading(false);
    }
  };

  const handleRefer = async () => {
    try {
      setActionLoading("refer");
      await submitReferCase(activeCaseNumber);
      toast.success("Case referred successfully.");
      navigate("/");
    } catch (error) {
      toast.error("Unable to refer the case.");
    } finally {
      setActionLoading(null);
    }
  };

  const handleNoAction = async () => {
    try {
      setActionLoading("no-action");
      await submitNoAction(activeCaseNumber);
      toast.success("No action submitted.");
      navigate("/");
    } catch (error) {
      toast.error("Unable to submit No Action.");
    } finally {
      setActionLoading(null);
    }
  };

  const handleCloseCase = async () => {
    if (!selectedReason) {
      toast.error("Please select a reason to close the case.");
      return;
    }
    try {
      setActionLoading("close");
      await submitCloseCase(activeCaseNumber, { case_closure_reason_code: selectedReason });
      toast.success("Case closed successfully.");
      navigate("/");
    } catch (error) {
      toast.error("Unable to close the case.");
    } finally {
      setActionLoading(null);
    }
  };

  const handleDownloadResult = async () => {
    if (!activeCaseNumber) {
      toast.error("No active case available.");
      return;
    }
    try {
      setDownloadResultLoading(true);
      await downloadGenericResult(activeCaseNumber);
    } catch (error) {
      toast.error("Unable to download result.");
    } finally {
      setDownloadResultLoading(false);
    }
  };

  const isActionDisabled = (type) =>
    !allAcknowledged || (actionLoading && actionLoading !== type);

  const footerActions = [
  ];

  return (
    <StatusLayout
      title="Referred to SSA"
      description="Your case is currently being reviewed by the Social Security Administration (SSA). Please wait for the status to update. No further action is required from you at this time."
      footerActions={footerActions}
    >
      <div className="status-section">
        <h3>Available Documents</h3>
        <p>You may download the following documents for your records:</p>
        
        <div className="status-actions">
          <button
            className="status-primary"
            onClick={handleDownloadNotice}
            disabled={downloadNoticeLoading}
          >
            {downloadNoticeLoading
              ? "Downloading..."
              : "Download Further Action Notice"}
          </button>

          <button
            className="status-primary"
            onClick={handleDownloadReferralDate}
            disabled={downloadReferralDateLoading}
          >
            {downloadReferralDateLoading
              ? "Downloading..."
              : "Download Referral Date Confirmation"}
          </button>
        </div>
      </div>
    </StatusLayout>
  );
};

export default PendingReferralPage;
